import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  /* eslint-disable prettier/prettier */
  return {
    //  Integrations
    getIntegrationsByTag: (lang, tag) => `${baseURL}/lang/${lang}/tag/${tag}`,
  }
  /* eslint-enable prettier/prettier */
})(process.env.BEINTEGRATIONCATALOG_URL)

/**
 * @typedef {Object} PoweredBy
 * @property {string} client_id
 * @property {string} logo
 * @property {string} title
 *
 * @typedef {Object} InlineModel
 * @property {string} logo
 * @property {string} url
 * @property {string} title
 * @property {string} excerpt
 * @property {string} date_gmt
 * @property {string} modified_gmt
 * @property {string} client_id
 * @property {string} service_type
 * @property {boolean} enabled
 * @property {boolean} banned
 * @property {PoweredBy} powered_by
 *
 *
 * @description Gets the integrations by tag.
 * @param {string} lang The language
 * @param {string} tag The tag
 * @returns {Promise<Array<InlineModel>>}
 */
export const beIntegrationCatalogGetIntegrationsByTag = (lang, tag) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getIntegrationsByTag(lang, tag),
  }).then((res) => res.data)
}
